// extracted by mini-css-extract-plugin
module.exports = {"candidateSocialButton":"CandidateSocialButtons_candidateSocialButton__EwhMb","tooltip":"CandidateSocialButtons_tooltip__l5T2M"};